import NextHead from "next/head";
import "focus-visible";

import "@fontsource/noto-sans-jp/400.css";
import "@fontsource/noto-sans-jp/700.css";
import "@fontsource/noto-serif-jp/400.css";
import "@fontsource/noto-serif-jp/700.css";
import "@fontsource/yakuhanjp/400.css";
import "@fontsource/yakuhanjp/700.css";
import "@fontsource/yakuhanmp/400.css";
import "@fontsource/yakuhanmp/700.css";
import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "@/styles/globals.scss";
config.autoAddCss = false;
import usePageView from "@/hooks/usePageView";
import GoogleAnalytics from "@/components/utils/GoogleAnalytics";
import { ShindanFloatingButton } from "@/components/organisms/ShindanFloatingButton";

function MyApp(props) {
  const { Component, pageProps } = props || {};
  usePageView();
  if (!Component) return null;
  return (
    <>
      <NextHead>
        <GoogleAnalytics />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
      </NextHead>
      <Component {...pageProps} />
      <ShindanFloatingButton />
    </>
  );
}
export default MyApp;
